import React, { useState, useContext, useMemo } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import '../css/pors/doc_process.css'; 
import { Button, Table, Form, InputGroup, Pagination, Container } from 'react-bootstrap';
import { MdLocalPrintshop, MdOutlineRestore, MdSearch, MdUnfoldMore, MdKeyboardArrowLeft, MdKeyboardArrowRight, MdEdit } from "react-icons/md";
import { ToastContainer, toast, Zoom } from 'react-toastify';
import { RiResetLeftFill } from "react-icons/ri";
import Swal from 'sweetalert2';
import { FaRegThumbsUp, FaRegThumbsDown } from "react-icons/fa";
import { motion, AnimatePresence } from 'framer-motion';

// Context & API
import Header from '../topbotm/Header';
import Footer from '../topbotm/Footer';
import Sidebar from '../dashboard/sidebar'; // Added Sidebar
import api from '../../api';
import { Dimcontext } from "../../context/pagecontext";
import { AuthContext } from '../../context/authContext';
import { Datacontext } from '../../context/dataContext'; 
import { Printdoc } from '../print/printdoc';
import { RejPrintdoc } from '../print/rej_print';
import { Editdoc } from '../edit/editdoc';

const Mydoc = () => {
  const { setDim } = useContext(Dimcontext);
  const { user } = useContext(AuthContext);
  const { documents, fetchDocuments, loading } = useContext(Datacontext);

  // UI States
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: 'application_no', direction: 'asc' });
  const [statusFilter, setStatusFilter] = useState(null); 
  const [edit, set_Edit] = useState(false);
  
  // Modal States
  const [docid, set_docid] = useState('');
  const [docview, setdocview] = useState(false);
  const [docrview, setdocrview] = useState(false);

  const showsToast = (msg) => toast.success(msg, { position: "bottom-center", autoClose: 1000, theme: "dark", transition: Zoom });

  // --- Core Filtering Logic ---
  const processedData = useMemo(() => {
    if (!documents) return [];

    const excludedStatuses = ["processing"];
    let filtered = documents.filter(d => !excludedStatuses.includes(d.docstatus));

    if (user?.role === "user") {
      filtered = filtered.filter(d => 
        d?.managed_By?.map(name => name.toLowerCase()).includes(user.name?.toLowerCase())
      );
    }

    if (statusFilter) filtered = filtered.filter(d => d.docstatus === statusFilter);

    if (searchTerm) {
      filtered = filtered.filter(doc => {
        const buyerName = doc?.buyers?.[0]?.buyer_Detail?.name || "";
        const searchStr = `${buyerName} ${doc.application_no} ${doc.register_office} ${doc.village} ${doc.register_document}`.toLowerCase();
        return searchStr.includes(searchTerm.toLowerCase());
      });
    }

    if (sortConfig.key) {
      filtered.sort((a, b) => {
        let aValue = sortConfig.key === 'name' ? (a?.buyers?.[0]?.buyer_Detail?.name || "") : a[sortConfig.key];
        let bValue = sortConfig.key === 'name' ? (b?.buyers?.[0]?.buyer_Detail?.name || "") : b[sortConfig.key];
        if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }
    return filtered;
  }, [documents, user, searchTerm, sortConfig, statusFilter]);

  // --- Pagination Logic ---
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = processedData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(processedData.length / rowsPerPage);

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') direction = 'desc';
    setSortConfig({ key, direction });
  };

  const handlerestore = async (id) => {
    try {
      // 1. Fire the confirmation alert
      const result = await Swal.fire({
        title: 'Restore Application?',
        text: "Are you sure you want to move this document back to Processing?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#8a2be2', // Matches your theme
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Restore it!'
      });

      // 2. Only proceed if the user clicked "Yes"
      if (result.isConfirmed) {
        await api.patch(`/updateone_Customer/${id}`, { data1: { docstatus: "processing" } });
        showsToast("Restored to Processing");
        fetchDocuments();
      }
    } catch (error) { console.error(error); }
  };

  const calculateProgress = (doc) => {
    const clickedCount = Object.values(doc).filter(field => field?.clicked > 0).length;
    return clickedCount === 0 ? 10 : Math.floor(clickedCount * 6.5 + 9);
  };

  const getBadgeColor = (name) => {
    const variants = ['primary', 'secondary', 'success', 'danger', 'warning', 'info'];
    return variants[(name?.length || 0) % variants.length];
  };

  const onclose = () => {
    setdocview(false);
    setdocrview(false);
    setDim(false);
  };

  const handleEdit = (id) =>{
    setDim(true);
    set_docid(id);
    set_Edit(true);
  };

  return (
    <div className="dashboard-page">
      <Header/>
      <ToastContainer />

      <div className="dashboard-wrapper">
        <div className='d-none' style={{backgroundColor:"#4a127e"}}>
                    <Sidebar user={user} />
                </div>

        <main className="main-area">
          <Container fluid="xxl" className="py-4 px-3 px-md-4">
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="main-glass-card shadow-sm border">
              <div className="card-header-custom d-flex justify-content-between align-items-center p-3">
                <h4 className="m-0 fw-bold text-dark">Document History</h4>
                
                <div className="d-flex gap-3 align-items-center">
                  {(searchTerm || statusFilter) && (
                    <RiResetLeftFill 
                      className="text-primary cursor-pointer" 
                      size={22} 
                      onClick={() => {setSearchTerm(''); setStatusFilter(null); setCurrentPage(1);}} 
                    />
                  )}
                  <InputGroup className="search-bar" style={{ width: '250px' }}>
                    <InputGroup.Text className="bg-white"><MdSearch size={20} className="text-muted" /></InputGroup.Text>
                    <Form.Control
                      placeholder="Search history..."
                      value={searchTerm}
                      onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                    />
                  </InputGroup>
                </div>
              </div>

              <div className="table-side-scroll-container">
                <Table hover striped responsive className="imtable mb-0">
                  <thead>
                    <tr>
                      <th className="sticky-col pin-no">NO.</th>
                      <th className="sticky-col pin-name cursor-pointer" onClick={() => handleSort('name')}>
                        NAME <MdUnfoldMore />
                      </th>
                      <th className="cursor-pointer" onClick={() => handleSort('application_no')}>
                                        APP NO <MdUnfoldMore />
                                      </th>
                                      <th>
                                        NATURE
                                      </th>
                                      <th className="cursor-pointer" onClick={() => handleSort('register_office')}>
                                        OFFICE <MdUnfoldMore />
                                      </th>
                      <th>MANAGED BY</th>
                      <th className="text-center">
                        <div className="d-flex align-items-center justify-content-center gap-2">
                          STATUS
                          <FaRegThumbsUp 
                            className={`cursor-pointer ${statusFilter === 'completed' ? 'text-success' : 'text-white'}`} 
                            onClick={() => {setStatusFilter(statusFilter === 'completed' ? null : 'completed'); setCurrentPage(1);}} 
                            color='white'
                          />
                          <FaRegThumbsDown 
                            className={`cursor-pointer ${statusFilter === 'rejected' ? 'text-danger' : 'text-white'}`} 
                            onClick={() => {setStatusFilter(statusFilter === 'rejected' ? null : 'rejected'); setCurrentPage(1);}} 
                            color='white'
                          />
                        </div>
                      </th>
                      <th className="text-center">ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr><td colSpan={8} className="text-center py-5"><div className="custom-loader"></div></td></tr>
                    ) : currentRows.length > 0 ? (
                      currentRows.map((doc, index) => (
                        <tr key={doc.id} className="align-middle">
                          <td className="sticky-col pin-no">{indexOfFirstRow + index + 1}</td>
                          <td className="sticky-col pin-name fw-semibold">{doc?.buyers?.[0]?.buyer_Detail?.name?.toUpperCase()}</td>
                          <td><span className="app-badge">{doc.application_no}</span></td>
                          <td><div className="text-truncate" style={{maxWidth: '120px'}}>{doc.register_document?.toUpperCase()}</div></td>
                          <td>{doc.register_office?.toUpperCase()}</td>
                          <td>
                            <div className="d-flex flex-wrap gap-1 justify-content-center">
                              {doc.managed_By?.map((m, i) => (
                                <span key={i} className={`badge rounded-pill bg-${getBadgeColor(m)}`} style={{fontSize: '0.6rem'}}>
                                  {m?.toUpperCase()}
                                </span>
                              ))}
                            </div>
                          </td>
                          <td className="text-center">
                            {doc.docstatus === 'rejected' ? (
                              <div className="d-flex flex-column align-items-center">
                                <div style={{ width: 35, height: 35 }}>
                                  <CircularProgressbar
                                    value={calculateProgress(doc)} 
                                    text={`${calculateProgress(doc)}%`}
                                    styles={buildStyles({ textSize: '30px', pathColor: '#dc3545', textColor: '#dc3545' })}
                                  />
                                </div>
                                <small className="text-danger fw-bold" style={{fontSize: '9px'}}>{doc.rejreason}</small>
                              </div>
                            ) : (
                              <span className="badge rounded-pill bg-success">Completed</span>
                            )}
                          </td>
                          <td className="text-center">
                            <div className="d-flex justify-content-center gap-2">
                              {doc.docstatus === "rejected" && user?.role === "admin" && (
                                <Button variant="outline-primary" size="sm" onClick={() => handlerestore(doc.id)}>
                                  <MdOutlineRestore size={18} />
                                </Button>
                              )}
                              <Button 
                                className={`btn-action ${doc.docstatus === 'rejected' ? 'br' : 'bp'}`} 
                                onClick={() => {set_docid(doc.id); setDim(true); doc.docstatus === "rejected" ? setdocrview(true) : setdocview(true);}}
                              >
                                <MdLocalPrintshop size={18} />
                              </Button>
                              {user?.role === "admin" && (<Button className="btn-action br" onClick={() => handleEdit(doc.id)}><MdEdit /></Button>)}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr><td colSpan={8} className="text-center py-5 text-muted">No records found.</td></tr>
                    )}
                  </tbody>
                </Table>
              </div>

              <div className="pagination-footer d-flex flex-column flex-md-row justify-content-between align-items-center p-3 border-top bg-light gap-3">
    {/* Left Side: Rows per page */}
    <div className="d-flex align-items-center gap-2">
        <span className="text-muted small">Rows per page:</span>
        <Form.Select 
            size="sm" 
            style={{ width: '80px', borderRadius: '6px' }}
            value={rowsPerPage} 
            onChange={(e) => { 
                setRowsPerPage(Number(e.target.value)); 
                setCurrentPage(1); 
            }}
        >
            {[10, 20, 50, 100].map(v => (
                <option key={v} value={v}>{v}</option>
            ))}
        </Form.Select>
    </div>

    {/* Middle: Data Summary */}
    <div className="text-muted small fw-medium">
        {processedData.length > 0 ? (
            <>
                Showing <b>{indexOfFirstRow + 1}</b> to <b>{Math.min(indexOfLastRow, processedData.length)}</b> of <b>{processedData.length}</b> entries
            </>
        ) : (
            "No entries to show"
        )}
    </div>

    {/* Right Side: Navigation */}
    <Pagination className="mb-0 custom-pagination shadow-sm">
        <Pagination.First 
            disabled={currentPage === 1} 
            onClick={() => setCurrentPage(1)} 
        />
        <Pagination.Prev 
            disabled={currentPage === 1} 
            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
        >
            <MdKeyboardArrowLeft size={20} />
        </Pagination.Prev>

        {/* Current Page Indicator */}
        <Pagination.Item active className="px-2">{currentPage}</Pagination.Item>

        <Pagination.Next 
            disabled={currentPage === totalPages || totalPages === 0} 
            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
        >
            <MdKeyboardArrowRight size={20} />
        </Pagination.Next>
        <Pagination.Last 
            disabled={currentPage === totalPages || totalPages === 0} 
            onClick={() => setCurrentPage(totalPages)} 
        />
    </Pagination>
</div>
            </motion.div>
          </Container>
        </main>
      </div>

      <AnimatePresence>
        {(docview || docrview) && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="modal-wrapper">
             {docview && <Printdoc setdocview={setdocview} id={docid} onclose={onclose} showsToast={showsToast} />}
             {docrview && <RejPrintdoc setdocrview={setdocrview} id={docid} onclose={onclose} showsToast={showsToast} />}
          </motion.div>
        )}
        {edit && (
          <motion.div
            key="edit-modal"
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="modal-wrapper"
          >
            <Editdoc set_docedit={set_Edit} id={docid} showToast={toast.warn} onclose={fetchDocuments}/>
          </motion.div>
        )}
      </AnimatePresence>
      <Footer />
    </div>
  );
};

export default Mydoc;